import React from 'react'

import useHoverEvent from 'helpers/useHoverEvent'

const defaultEvProps = {
  engagementGA4Name: 'engagement_hover',
}

/** @type {import("./types").default} */
const HoverEvent = ({ className = '', children, event = defaultEvProps, ...rest }) => {
  const hoverHandlers = useHoverEvent(event)

  return (
    <div className={className} {...hoverHandlers} {...rest}>
      {children}
    </div>
  )
}

export default HoverEvent
